<script setup>
    import { ref, computed } from 'vue'
    import SingleEdit from '@/js/components/Common/SingleEdit.vue'
    import { TextareaField } from '@/js/components/Common'

    const props = defineProps({
        benotung: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() => (props.language === 'englisch' ? 'Grading | Benotung' : 'Benotung'))

    const emit = defineEmits(['benotungSaved'])

    let editBenotung = ref('')

    function handleEditStart() {
        editBenotung.value = props.benotung
    }

    function handleEditAbort() {
        editBenotung.value = ''
    }

    const saveBenotung = () => {
        emit('benotungSaved', editBenotung.value)
    }
</script>

<template>
    <single-edit
        :entry="benotung"
        :title="title"
        :tool-tip="tooltip"
        edit-key="benotung"
        :allow-edit="allowEdit"
        @text-saved="saveBenotung"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <textarea-field v-model="editBenotung" class="w-100 h-100" />
        </template>
    </single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
